/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { BrandSelectorEnabled } from '../../interface/models';

export const isBrandSelectorEnabled = (item: unknown): item is BrandSelectorEnabled => {
  if (!item) {
    return false;
  }

  return Boolean(
    typeof item === 'object' &&
    'brand_filter' in item &&
    item.brand_filter &&
    'brand_selector' in item &&
    Array.isArray(item.brand_selector),
  );
};
